import { AnimatePresence, motion } from "framer-motion"
import styled from "styled-components"
// eslint-disable-next-line import/no-named-as-default-member, import/namespace, import/default, import/no-named-as-default
import screenfull from "screenfull"

import FullscreenButton from "./FullscreenButton"
import ButtonIcon from "./ButtonIcon"
import { EASINGS } from "../constants"


const StyledMenu = styled(motion.div)`
  position: fixed;
  top: 0px;
  height: 96px;
  display: flex;
  flex-direction: row;
  align-content: top;
  justify-content: space-between;
  align-items: top;
  width: inherit;
  color: currentColor;
  padding: 12px 8px;
  pointer-events: none;
  background: ${(props) =>
    props.$hasGradient ? `linear-gradient(to bottom, rgba(0,0,0,0.4), rgba(0,0,0,0))` : `none`};
`

const StyledHeadline = styled(motion.h1)`
  font-size: 1.5rem;
  line-height: 2rem;
  color: white;
  margin-top: 4px;
  margin-right: auto;
  margin-left: 8px;
`

const animations = {
  menu: {
    variants: {
      visible: {
        opacity: 1,
        transition: {
          opacity: {
            duration: 0.5,
            delay: 0.5,
          },
          easing: EASINGS.inSine,
        },
      },
      hidden: {
        opacity: 0,
        transition: {
          opacity: {
            duration: 0.5,
          },
          easing: EASINGS.outSine,
        },
      },
    },
    initial: "hidden",
    animate: "visible",
    exit: "hidden",
  },
  title:{
    variants: {
      visible: {
        opacity: 1,
        transition: {
          opacity: {
            duration: 0.5,
          },
          easing: EASINGS.inSine,
        },
      },
      hidden: {
        opacity: 0,
        transition: {
          opacity: {
            duration: 0.5,
            delay: 1.5,
          },
          easing: EASINGS.outSine,
        },
      },
    },
    initial: "visible",
    animate: "hidden",
  }
}

const Menu = ({
  title,
  isVisible = true,
  isFullscreenButtonVisible,
  onClose,
  hasGradient = true,
  hasClose = false,
  ...style
}) => {
  return (
    <AnimatePresence>
      {isVisible && (
        <StyledMenu key={"Menu"} {...animations.menu} $hasGradient={hasGradient} {...style}>
          <ButtonIcon iconName={hasClose ? "IconClose" : "IconMenu"} onClick={onClose} />
          {title && <StyledHeadline {...animations.title}>{title}</StyledHeadline>}
          {screenfull.isEnabled && <FullscreenButton isVisible={isFullscreenButtonVisible} />}
        </StyledMenu>
      )}
    </AnimatePresence>
  )
}

export default Menu
